import { api } from '../api';

// Get all notifications for the current user
export const getNotifications = async () => {
  try {
    const response = await api.get('/getNotifications');
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

// Get unread notification count
export const getUnreadNotificationCount = async () => {
  try {
    const response = await api.get('/getUnreadNotificationCount');
    return response.data.count;
  } catch (error) {
    console.error('Error fetching unread notification count:', error);
    throw error;
  }
};

// Mark a specific notification as read
export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await api.post(`/markNotificationAsRead/${notificationId}`);
    return response.data;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw error;
  }
};

// Mark all notifications as read
export const markAllNotificationsAsRead = async () => {
  try {
    const response = await api.post('/markAllNotificationsAsRead');
    return response.data;
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    throw error;
  }
};

// Format notification timestamp for display
export const formatNotificationTime = (timestamp) => {
  const now = new Date();
  const notifTime = new Date(timestamp);
  const diffInMs = now - notifTime;
  const diffInMins = Math.floor(diffInMs / 60000);
  const diffInHours = Math.floor(diffInMins / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInMins < 1) {
    return 'Just now';
  } else if (diffInMins < 60) {
    return `${diffInMins}m ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  } else if (diffInDays < 7) {
    return `${diffInDays}d ago`;
  } else {
    return notifTime.toLocaleDateString();
  }
};

// Get notification type from message content
export const getNotificationType = (message) => {
  if (message.includes('liked your post')) {
    return 'like';
  } else if (message.includes('commented on your post')) {
    return 'comment';
  } else if (message.includes('created a new post')) {
    return 'post';
  } else if (message.includes('Summary')) {
    return 'summary';
  } else if (message.includes('PIN')) {
    return 'admin';
  } else if (message.includes('Welcome')) {
    return 'welcome';
  }
  return 'general';
};
